import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'

function Row({ label, value }) {
  return (
    <div style={{ display: 'flex', gap: 12, padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
      <span style={{ minWidth: 180, fontSize: '0.82rem', color: 'var(--ink-soft)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', flexShrink: 0 }}>
        {label}
      </span>
      <span style={{ fontSize: '0.95rem', color: 'var(--ink)', wordBreak: 'break-word' }}>
        {value || <span style={{ color: 'var(--ink-soft)', fontStyle: 'italic' }}>—</span>}
      </span>
    </div>
  )
}

export default function ProfileView() {
  const { id } = useParams()
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError]     = useState('')

  useEffect(() => {
    const load = async () => {
      const { data, error } = await supabase
        .from('profiles').select('*').eq('id', id).single()
      if (error) setError(error.message)
      else if (!data) setError('Profile not found or access denied.')
      else setProfile(data)
      setLoading(false)
    }
    load()
  }, [id])

  if (loading) return (
    <div className="loading-screen">
      <div className="loading-spinner" />
      <p>Loading profile…</p>
    </div>
  )

  if (error || !profile) return (
    <div className="loading-screen">
      <p style={{ color: 'var(--red)' }}>⚠ {error || 'Profile not found.'}</p>
      <button className="btn btn-ghost" style={{ marginTop: 16, width: 'auto', padding: '9px 20px' }}
        onClick={() => window.close()}>
        Close tab
      </button>
    </div>
  )

  const registered = new Date(profile.created_at).toLocaleDateString('en-IN', {
    day: 'numeric', month: 'long', year: 'numeric'
  })
  const updated = new Date(profile.updated_at).toLocaleDateString('en-IN', {
    day: 'numeric', month: 'long', year: 'numeric'
  })

  return (
    <div className="page-layout">
      <div className="topbar">
        <div className="topbar-brand">
          <div className="topbar-logo-mark">↑</div>
          <span className="topbar-logo-name">Uplift</span>
        </div>
        <div className="topbar-actions">
          <span style={{ fontSize: '0.78rem', color: 'var(--ink-soft)', background: 'var(--uplift-pale2)', padding: '4px 10px', borderRadius: 20, fontWeight: 600 }}>
            Admin · Read-only view
          </span>
          <button className="btn btn-ghost" onClick={() => window.close()}
            style={{ width: 'auto', padding: '7px 18px', fontSize: '0.85rem' }}>
            Close tab
          </button>
        </div>
      </div>

      <div className="page-content">
        <div className="page-header">
          <h1>{profile.full_name || 'Unnamed profile'}</h1>
          <p style={{ fontSize: '0.82rem', color: 'var(--ink-soft)' }}>
            Registered {registered} · Last updated {updated}
          </p>
        </div>

        <div className="form-card">

          <div className="section-label">👤 Personal Information</div>
          <Row label="Full name"   value={profile.full_name} />
          <Row label="Age"         value={profile.age} />
          <Row label="Gender"      value={profile.gender} />

          <div className="section-label" style={{ marginTop: 24 }}>📞 Contact Details</div>
          <Row label="Email"  value={profile.email} />
          <Row label="Phone"  value={profile.phone} />

          <div className="section-label" style={{ marginTop: 24 }}>📍 Address</div>
          <Row label="Address"   value={profile.address_line1} />
          <Row label="City"      value={profile.city} />
          <Row label="District"  value={profile.district} />
          <Row label="State"     value={profile.state} />
          <Row label="PIN Code"  value={profile.pin_code} />

          <div className="section-label" style={{ marginTop: 24 }}>🎓 Education</div>
          <Row label="Qualification" value={profile.education_level} />
          <Row label="Details"       value={profile.education_detail} />

        </div>
      </div>
    </div>
  )
}
